import React, { createContext, useContext } from 'react'

export const Context = createContext({ path: '' })

export const ItemContextProvider = ({ children, path }) => {
	return <Context.Provider value={{ path }}>{children}</Context.Provider>
}

export const useItemContext = () => {
	const context = useContext(Context)

	return { path: context.path }
}
